module.exports = __webpack_public_path__ + "static/media/form-icon.f3cba557.jpg";